import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appPosition]',
  standalone: true
})
export class PositionDirective implements OnInit {
  @Input('position') position!: { top: number; left: number };

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    const parent = this.el.nativeElement.offsetParent;

    if (parent) {
      const parentWidth = parent.clientWidth;
      const parentHeight = parent.clientHeight;

      // Asegura que las posiciones no se salgan del contenedor
      const top = Math.max(0, Math.min(this.position.top, parentHeight - this.el.nativeElement.offsetHeight));
      const left = Math.max(0, Math.min(this.position.left, parentWidth - this.el.nativeElement.offsetWidth));

      // Aplica las posiciones al elemento
      this.renderer.setStyle(this.el.nativeElement, 'position', 'absolute');
      this.renderer.setStyle(this.el.nativeElement, 'top', `${top}px`);
      this.renderer.setStyle(this.el.nativeElement, 'left', `${left}px`);
    }
  }
}
